
      import Audit from './audit.vue'
      import type { App, Plugin } from 'vue'

      export const AuditPlugin: Plugin = {
        install(app: App) {
          app.component('Audit', Audit)
        },
      }
      export { Audit }
      